import React from 'react';

import ReviewSection from '@hydra/common/components/ReviewSection';
import * as CriteriaList from '@hydra/common/criteria';
import ReviewModule from '../Review/ReviewModule';
import Translate from '@hydra/common/components/i18n';
import useResizeIframe from '@hydra/common/customHooks/useResizeIframe';

import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import ReviewTeaserNoCritCTA from './ReviewTeaserNoCritCTA';
import { useReviewContext } from '@hydra/common/context/review';

const useStyles = makeStyles(theme => ({
  hide: { display: 'none' },
  show: { display: 'block' },
  emptyFilter: {
    padding: theme.spacing(2),
    textAlign: 'center'
  }
}));

export function ReviewTeaserPreviewFull (props) {
  const classes = useStyles();
  const {
    criteria,
    components: { Module = ReviewModule } = {},
    url,
    competitors,
    reviewStructure = {},
    showCrit = () => true,
    showModule = () => true,
    showSection = () => true,
    onpageReviewFilter = null
  } = props;
  const showSections = {
    on_page: showSection({ section: 'on_page', onpageReviewFilter }),
    off_page: showSection({ section: 'off_page', onpageReviewFilter })
  };

  const setElm = useResizeIframe();
  const { variant } = useReviewContext();

  return (
    <>
      <div
        className={(showSections.on_page || showSections.off_page) ? classes.show : classes.hide}
        ref={setElm}
      >
        {(variant === 'nocrit') && <ReviewTeaserNoCritCTA />}
        {reviewStructure.on_page && (
          <ReviewSection
            section='on_page'
            className={showSections.on_page ? classes.show : classes.hide}
          >
            {Object.keys(reviewStructure.on_page).map((module, index) => (
              <React.Fragment key={index}>
                <Module
                  module={module}
                  key={module}
                  className={showModule({ module, section: 'on_page', onpageReviewFilter }) ? classes.show : classes.hide}
                >
                  {reviewStructure.on_page[module].map(crit => {
                    const Criteria = CriteriaList[crit];
                    return (
                      <div className={showCrit({ crit, onpageReviewFilter }) ? classes.show : classes.hide} key={crit}>
                        <Criteria
                          criterium={criteria[crit]}
                          competitors={competitors}
                          url={url}
                        />
                      </div>
                    );
                  })}
                </Module>
              </React.Fragment>
            ))}
          </ReviewSection>
        )}
        {reviewStructure.off_page && (
          <ReviewSection
            section='off_page'
            className={showSections.off_page ? classes.show : classes.hide}
          >
            {Object.keys(reviewStructure.off_page).map(module => (
              <Module
                module={module}
                key={module}
                className={showModule({ module, section: 'off_page', onpageReviewFilter }) ? classes.show : classes.hide}
              >
                {reviewStructure.off_page[module].map(crit => {
                  const Criteria = CriteriaList[crit];
                  return (
                    <div className={showCrit({ crit, onpageReviewFilter }) ? classes.show : classes.hide} key={crit}>
                      <Criteria
                        criterium={criteria[crit]}
                        competitors={competitors}
                        url={url}
                      />
                    </div>
                  );
                })}
              </Module>
            ))}
          </ReviewSection>
        )}
      </div>
      <div className={!showSections.on_page && !showSections.off_page ? classes.show : classes.hide}>
        <Paper className={classes.emptyFilter}>
          <Translate content='review_filter_empty_state' />
        </Paper>
      </div>
    </>
  );
}

export default ReviewTeaserPreviewFull;
